import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useFetalDeathChartsDataContext } from './hooks/useFetalDeathChartsDataContext';

export const PregnancyMonths = () => {
    const { chartData } = useFetalDeathChartsDataContext();


    return (
        <SimpleBars
            title={'Meses de gestação'}
            horizontal={true}
            subtitles={chartData?.pregnancyMonths?.map((item) => item.description)}
            values={chartData?.pregnancyMonths?.map((item) => item.total  ||  0)}
        />
    );
};
